import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const money = (settings) => (v) => `${settings.currency_code || ""} ${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`.trim();

export const exportPdf = ({ settings, title, sections, filename }) => {
  const doc = new jsPDF();
  const m = money(settings);
  doc.setFontSize(18);
  doc.text(settings.farm_name || "Farm", 14, 18);
  doc.setFontSize(12);
  doc.text(title, 14, 26);
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text(`Generated ${new Date().toLocaleString()}`, 14, 32);
  doc.setTextColor(0);
  let y = 40;
  sections.forEach((s) => {
    if (s.heading) { doc.setFontSize(12); doc.text(s.heading, 14, y); y += 3; }
    autoTable(doc, {
      startY: y,
      head: [s.columns],
      body: s.rows.map((r) => r.map((c) => (typeof c === "object" && c?.money !== undefined ? m(c.money) : c ?? ""))),
      foot: s.foot ? [s.foot.map((c) => (typeof c === "object" && c?.money !== undefined ? m(c.money) : c))] : undefined,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [31, 61, 43] },
      footStyles: { fillColor: [240, 240, 235], textColor: 20, fontStyle: "bold" },
    });
    y = doc.lastAutoTable.finalY + 12;
  });
  doc.save(filename || `${title.replace(/\s+/g, "-").toLowerCase()}.pdf`);
};
